import React from "react"
import { Modal, ModalBody } from "reactstrap"
import { withTranslation } from 'react-i18next'
import withRouter from '../Common/withRouter'

const CancelModal = (props) => {
  return (
    <Modal isOpen={props.show} toggle={props.onCloseClick} backdrop={'static'} centered={true}>
        <ModalBody className="py-3 px-5">
            <div className="mt-2 text-center">
                <div className="mt-4 pt-2 mx-4 mx-sm-5">
                    <i className="fa fa-trash"></i>
                    <h4>{props.t("are_you_sure")}</h4>
                    <span>{props.t("sure_to_cancel")}</span>
                </div>
                <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                    <button
                        type="button"
                        className="btn w-sm btn-light"
                        data-bs-dismiss="modal"
                        onClick={props.onCloseClick}
                    >
                        {props.t("close")}
                    </button>
                    <button
                        type="button"
                        className="btn w-sm btn-warning"
                        id="delete-record"
                        onClick={props.onCancelClick}
                    >
                        {props.t("yes_cancel_it")}
                    </button>
                </div>

            </div>
        </ModalBody>

    </Modal>
  )
}

export default withRouter(withTranslation()(CancelModal))
